<template>
  <el-dialog :visible.sync="showDialog" :close-on-click-modal="false" @close="handleClose" >
    <template #title>
      <h4>{{ isEdit ? $t('编辑') : $t('新增') }}</h4>
    </template>

    <el-form label-width="auto" label-position="left" ref="form" :model="formData" :rules="rules">
      <el-form-item :label="$t('图片')" prop="photo">
        <pic-upload
            width="80px"
            height="80px"
            :download-url="$api.file.downloadImg"
            :action="$api.file.upload"
            v-model="formData.photo"
            :limit="1"/>
        <span style="color: red">{{$t('建议大小')}} 702 * 390</span>
      </el-form-item>


      <el-form-item :label="$t('优先级')" prop="priority">
        <el-input :placeholder="$t('优先级别')" v-model.number="formData.priority"/>
      </el-form-item>

      <el-form-item :label="$t('状态')">
        <dict-select flag="BANNER_STATUS" v-model="formData.status"/>
      </el-form-item>

      <el-form-item :label="$t('滑动设置')">
        <div class="flex">
          <el-input :placeholder="$t('滑动设置')" v-model.number="formData.slideSet"/>
          <span style="flex-shrink: 0; margin-left: 10px">{{$t('单位')}}：{{$t('秒')}}</span>
        </div>
      </el-form-item>

      <el-form-item :label="$t('类型')">
        <el-radio-group v-model="formData.type">
          <el-radio label="cb" value="cb">{{$t('内链')}}</el-radio>
          <el-radio label="link" value="link">{{$t('外链')}}</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item :label="$t('广告链接网址')" prop="link" v-if="formData.type==='link'">
        <el-input :placeholder="$t('广告链接网址')" v-model="formData.link"/>
      </el-form-item>

      <el-form-item :label="$t('食谱编号')" v-if="formData.type==='cb'" style="width: 100%">
        <el-select v-model="formData.link" :placeholder="$t('食谱编号')" filterable  remote :remote-method="remoteMethod" :loading="loading"  style="width: 100%" clearable >
          <el-option v-for="item in recepListNum" :key="item.num" :value="item.num" :label="item.name"/>
        </el-select>
      </el-form-item>


    </el-form>

    <template #footer>
      <el-button type="primary" @click="handleConfirm">{{$t('确定')}}</el-button>
      <el-button @click="resetForm">{{$t('重置')}}</el-button>
    </template>

  </el-dialog>
</template>

<script>
import PicUpload from "@/components/pic-upload/PicUpload";
import {resetEmpty} from "@/utils/common";
import DictSelect from "@/components/dict/DictSelect";
import {request} from "@/config/request";

// 默认字段

export default {
  name: "BannerAddOrEdit",
  components: {DictSelect, PicUpload},
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      showDialog: false,
      formData: {
        photo: "",
        priority: null,
        link: "",
        status: "open",
        slideSet: null,
        type: "cb",
      },
      loading: false,

      recepListNum: [],

      rules: {
        photo: {required: true, message: this.$t('请上传图片'), trigger: "change"},
        priority: [
          {required: true, message: this.$t('请输入优先级'), trigger: "blur"},
          {type: "number", message: this.$t('优先级必须为数字值'), trigger: "blur"}
        ],
        link: [
          {required: true, message: this.$t('请输入链接地址'), trigger: "blur"},
          {pattern: /^https?:\/\//, message: this.$t('请输入正确的链接地址'), trigger: "blur"}
        ],
      }
    }
  },
  methods: {
    handleConfirm() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.$emit("save", {...this.formData});
      })
    },

    resetForm() {
      this.$refs.form.resetFields();
      resetEmpty(this.formData);
      this.formData = {
        ...this.formData, status: "open",
        slideSet: null,
        type: "cb",
      };
    },
    handleClose(){
      this.resetForm();
      this.recepListNum = [];
    },
   async  remoteMethod(query) {
      if (!query){
        return;
      }
      const res = await request(this.$api.cookbook.list,{
        num:query
      },{
        showLoading:false
      });
      const newArray = res.cookbooks.map(item =>{
        return {
          num:item.num,
          name:item.name
        }
      });
      this.recepListNum=[...newArray];
    }

  },
  watch: {
    // 监听上传图片
    "formData.photo": {
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            this.$refs.form.clearValidate("photo");
          })
        }
      }
    },
    data: {
      handler(val) {
        console.log(val)
        if (Object.values(val).length > 0) {

          for (const key in this.formData) {
            this.$set(this.formData, key, val[key]);
          }
          this.formData.priority = parseInt(this.formData.priority);
        } else {
          return
        }
      },
      immediate: true,
    },

  },
  // mounted() {
  //   this.getRecepListNum();
  // }
}
</script>

<style scoped>
/deep/ .el-dialog {
  width: 550px;
  border-radius: 10px;
}
</style>
